import React from "react";
import instaLogo from "../icons/Instagram.svg";
import faceLogo from "../icons/facebook.svg";
import tiktokLogo from "../icons/tiktok.svg";

function Contact() {
  return (
    <div className='iconContainer'>
      <div className='iconBox'>
        <a
          href='https://www.instagram.com/tyronelayne/'
          target='_blank'
          rel='noopener noreferrer'
          aria-label="Tyrone Layne on Instagram"
        >
          <img
            className='icon'
            src={instaLogo}
            alt="Instagram"
          />
        </a>
        <a
          href='https://www.facebook.com/tyrone.layne.artist/'
          target='_blank'
          rel='noopener noreferrer'
          aria-label="Tyrone Layne on Facebook"
        >
          <img
            className='icon'
            src={faceLogo}
            alt="Facebook"
          />
        </a>
        <a
          href='https://www.tiktok.com/@tyronelayne'
          target='_blank'
          rel='noopener noreferrer'
          aria-label="Tyrone Layne on TikTok"
        >
          <img
            className='icon'
            src={tiktokLogo}
            alt="TikTok"
          />
        </a>
      </div>
    </div>
  );
}

export default Contact;
